import { useCallback, useEffect, useMemo, useState } from 'react';
import { sentenceCase } from 'change-case';
import { useDispatch } from 'react-redux';
// material
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import { MdWatchLater } from 'react-icons/md';
// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Label from '../../components/Label';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user/index';
import { fDate, fDateTime1, fDateTime2 } from '../../utils/formatTime';
import { NOT_AVAILABLE } from '../Global/Constants';
import Loader from '../Global/Loader';
import { StyledTableCell, StyledTableRow } from '../Global/Styling';
import CallCenterToolbar from './CallCenterToolbar';
// import useCallCenterSelector from '../../store';
import useCallCenterSelector from '../../store/Slice/CallCenterList/CallCenterListSelector';
import { getCallCenterList } from '../../store/Slice/CallCenterList/CallCenterListSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import {
  getLoanTypeData,
  getSourceListData,
  getStatusList
} from '../../store/Slice/Global/GlobalSlice';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'randomPhoneNumber', label: 'Mobile Number', alignRight: false },
  { id: 'loanType', label: 'Loan Type', alignRight: false },
  { id: 'created', label: 'date', alignRight: false },
  { id: 'name', label: 'NAME', alignRight: false },
  { id: 'city', label: 'CITY', alignRight: false },
  { id: 'source', label: 'SOURCE', alignRight: false },
  { id: 'statusCallCenter', label: 'STATUS', alignRight: false },
  { id: 'recommendation', label: 'RECOMMENDATION', alignRight: false },
  { id: 'modifiedOn', label: 'Last update', alignRight: false },
  { id: 'noofcalls', label: 'NO OF CALLS', alignRight: false },
  { id: 'action', label: 'ACTION' }
];

/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function CallCenterList() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(600);
  const [openLoader, setOpenLoader] = useState(false);
  // const [openStatus, setOpenStatus] = useState(false);
  const [pageMenu, setPageMenu] = useState([]);
  const [filterDatesRange, setFilterDatesRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [page1, setPage1] = useState(1);
  const [selectLoanType, setSelectLoanType] = useState(' ');
  const [selectSource, setSelectSource] = useState(' ');
  const [selectStatus, setSelectStatus] = useState(' ');

  const { LoginData } = useLoginSelector();
  const { CallCenterData } = useCallCenterSelector();
  const callCenterListData = CallCenterData?.callCentreEntities || [];

  const dispatch = useDispatch();

  const handleLoanSelectLoan = (e) => {
    setSelectLoanType(e.target.value);
  };
  const handleSelectSource = (e) => {
    setSelectSource(e.target.value);
  };

  const handleSelectStatus = (e) => {
    setSelectStatus(e.target.value);
  };

  const handleRequestSort = (event, property) => {
    if (property !== 'action') {
      setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = callCenterListData?.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = useMemo(() =>
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - (callCenterListData?.length || 0))
      : (0)[(page, rowsPerPage, callCenterListData)]
  );

  const handleClick = (event, item) => {
    const selectedIndex = selected.indexOf(item);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const getLoanMasterApi = useCallback(() => {
    const obj = {
      companyId: LoginData?.companyId
    };
    dispatch(getLoanTypeData(obj));
  }, [LoginData]);

  // call center list
  const getCallCenterApi = useCallback(() => {
    const apiData = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      accessLevelId: LoginData?.accessLevelId,
      stageId: 54,
      callCentreFilterModel: {
        fromLeadDate:
          filterDatesRange[0].startDate !== null ? fDateTime2(filterDatesRange[0].startDate) : null,
        toLeadDate:
          filterDatesRange[0].endDate !== null ? fDateTime2(filterDatesRange[0].endDate) : null,
        leadStageStatusId: selectStatus !== ' ' ? selectStatus : null,
        sourceTypeId: selectSource !== ' ' ? selectSource : null,
        loanTypeId: selectLoanType !== ' ' ? selectLoanType : null
      },
      entityListRequestModel: {
        searchLiteral: filterName,
        pageSize: rowsPerPage,
        pageNumber: page1,
        sortOrder: order
      }
    };
    dispatch(getCallCenterList(apiData));
  }, [
    LoginData,
    filterDatesRange,
    selectStatus,
    selectSource,
    selectLoanType,
    filterName,
    rowsPerPage,
    page1,
    order
  ]);

  useEffect(() => {
    getCallCenterApi(); // call center list
    getLoanMasterApi(); // loan master list
    dispatch(getSourceListData()); // source list
    dispatch(getStatusList(54)); // status list
  }, [getCallCenterApi]);

  return (
    <Page title="Partner Management System || Call Center">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Call List" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Card>
            <CallCenterToolbar
              numSelected={selected.length}
              filterName={filterName}
              setFilterName={setFilterName}
              onFilterName={handleFilterByName}
              parent="call-center"
              pageMenu={pageMenu}
              filterDatesRange={filterDatesRange}
              setFilterDatesRange={setFilterDatesRange}
              selectLoanType={selectLoanType}
              setSelectLoanType={setSelectLoanType}
              onFilterLoan={handleLoanSelectLoan}
              selectSource={selectSource}
              setSelectSource={setSelectSource}
              onFilterSource={handleSelectSource}
              onFilterStatus={handleSelectStatus}
              selectStatus={selectStatus}
              setSelectStatus={setSelectStatus}
              selected={selected}
            />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, minHeight: '50vh', overflow: 'auto' }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={callCenterListData?.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    isCheckBox="true"
                  />
                  <TableBody>
                    {callCenterListData &&
                      callCenterListData?.length > 0 &&
                      callCenterListData?.map((item, index) => {
                        const isItemSelected = selected.indexOf(item) !== -1;
                        return (
                          <StyledTableRow
                            hover
                            key={index}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                onChange={(event) => handleClick(event, item)}
                              />
                            </TableCell>

                            <StyledTableCell align="left">
                              {item.mobile ? item.mobile : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item.loanType ? item.loanType : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item.leadDate ? fDate(item.leadDate) : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item.customerName ? item.customerName : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item.cityName ? item.cityName : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item.sourceTypeName ? item.sourceTypeName : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <Label
                                variant="ghost"
                                color={
                                  (item.callCenterStatus &&
                                    item.callCenterStatus === 'Not interested' &&
                                    'error') ||
                                  (item.callCenterStatus &&
                                    item.callCenterStatus === 'Not Doable' &&
                                    'warning') ||
                                  'success'
                                }
                              >
                                {item.callCenterStatus
                                  ? sentenceCase(item.callCenterStatus)
                                  : `${NOT_AVAILABLE}`}
                              </Label>
                              {item.callCenterStatus && item.callCenterStatus === 'Follow Up' ? (
                                <Tooltip
                                  title={
                                    item.followUpDateTime ? fDateTime1(item.followUpDateTime) : ''
                                  }
                                  placement="top"
                                  arrow
                                >
                                  <IconButton className="followUpIcon">
                                    <MdWatchLater size={18} />
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                ' '
                              )}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item.bankRecommendedName
                                ? item.bankRecommendedName
                                : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item.callCenterLastUpdatedOn
                                ? fDate(item.callCenterLastUpdatedOn)
                                : `${NOT_AVAILABLE}`}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item.callCount ? item.callCount : `${NOT_AVAILABLE}`}
                            </StyledTableCell>

                            <StyledTableCell align="" width="85">
                              <UserMoreMenu
                                rowId={item.leadId}
                                parent="call-center"
                                // setOpenStatus={setOpenStatus}
                              />
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <StyledTableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {callCenterListData?.length === 0 && (
                    <TableBody>
                      <TableRow>
                        <StyledTableCell
                          align="center"
                          colSpan={TABLE_HEAD.length + 1}
                          sx={{ py: 3 }}
                        >
                          <SearchNotFound searchQuery={filterName} />
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
          </Card>
          <Loader openLoader={openLoader} />
        </Box>
      </Container>
    </Page>
  );
}
